<template>

     <template v-if="currentSchoolyear && adminSchoolyear">

        <el-card shadow="hover">
            <el-row align="middle">
                <el-col :span="12">
                    <div class="text-left">
                        <h3>{{ $t('departmentsList') }}</h3>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="text-right">
                        <el-button size="default" @click="addItem()">
                            {{ $t('add') }}
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-table :data="pagedTableData" :empty-text="$t('noData')" style="width: 100%" border stripe v-loading="isLoading">

                <el-table-column type="index" :index="indexMethod"> </el-table-column>
                <el-table-column sortable :label="$t('name')" prop="name"> </el-table-column>
                <el-table-column sortable :label="$t('contact')" prop="contact"> </el-table-column>
                <el-table-column sortable :label="$t('position')" prop="idx">
                    <template #default="scope">
                        <el-tag>{{scope.row.idx}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column align="right">

                    <template #header>
                        <el-input v-model="search" size="small" :placeholder="$t('search')" />
                    </template>

                    <template #default="scope">
                        <el-button size="small" @click="editItem(scope.$index, scope.row)">
                            {{ $t('edit') }}
                        </el-button>
                        <el-button size="small" type="danger" @click="deleteItem(scope.$index, scope.row)">
                            {{ $t('delete') }}
                        </el-button>
                    </template>

                </el-table-column>

            </el-table>

            <div style="text-align: center; margin-top: 20px">

                <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="setPage"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>

            </div>
        </el-card>

        <el-dialog :title="$t('addDepartment')" v-model="addDialog" width="65%">

            <el-form :inline="true" :model="addDepartment" :rules="rules" :ref="addDepartmentForm">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="addDepartment.name"/>
                </el-form-item>

                <el-form-item prop="contact" :label="$t('contact')">
                    <el-input
                        :placeholder="$t('contact')"
                        v-model="addDepartment.contact"/>
                </el-form-item>

                <el-form-item prop="idx" :label="$t('position')">
                    <el-input-number v-model="addDepartment.idx" :min="1"/>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(addDepartmentForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(addDepartmentForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

        <el-dialog :title="$t('editDepartment')" v-model="editDialog" width="65%">

            <el-form :inline="true" :model="editDepartment" :rules="rules" :ref="editDepartmentForm">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="editDepartment.name"/>
                </el-form-item>

                <el-form-item prop="contact" :label="$t('contact')">
                    <el-input
                        :placeholder="$t('contact')"
                        v-model="editDepartment.contact"/>
                </el-form-item>

                <el-form-item prop="idx" :label="$t('position')">
                    <el-input-number v-model="editDepartment.idx" :min="1"/>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(editDepartmentForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(editDepartmentForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

     </template>

     <el-alert :title="$t('noCurrentSchoolyearWarning')" type="warning" v-else/>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import fr from 'element-plus/lib/locale/lang/fr'

import accessManager from '@/mixins/access-manager'

export default {
    name: 'Departments',
    mixins: [accessManager],
    data() {
      return {
        primaryColor: process.env.VUE_APP_PRIMARY_COLOR,
        editDepartment: {
            name: '',
            contact: '',
            idx: 1
        },
        addDepartment: {
            name: '',
            contact: '',
            idx: 1
        },
        rules: {
            name: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            contact: [
                {
                    required: false
                }
            ],
            idx: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ]
        },
        editDepartmentForm: 'editDepartmentForm',
        addDepartmentForm: 'addDepartmentForm',
        currentEditItem: null,
        editDialog: false,
        isLoading: false,
        addDialog: false,
        tableData: [],
        pageSize: 6,
        locale: fr,
        search: '',
        total: 0,
        page: 1
      }
    },
    created() {

      this.fetchDepartments()

    },
    computed:{
      ...mapState({
        userData: state => state.session.userData
      }),
      ...mapGetters({
        getSettingValue: 'settings/getSettingValue'
      }),
      pagedTableData() {

        this.total = this.searching.length

        return this.searching.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)

      },
      searching() {

        if (!this.search) {
            this.total = this.tableData.length
            return this.tableData
        }

        this.page = 1

        return this.tableData.filter(data => (
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            (data.contact && data.contact.toLowerCase().includes(this.search.toLowerCase()))
        ))

      }
    },
    methods: {
      ...mapActions({
         fetchDepartmentsDB: 'departments/fetchDepartmentsDB',
      }),
      setPage (val) {

         this.page = val

      },
      indexMethod(index) {

         return index + ((this.page - 1) * this.pageSize) + 1

      },
      async fetchDepartments(){

        if (!this.adminSchoolyear) return

        this.isLoading = true

        let resp = await this.fetchDepartmentsDB({
            action: 'getDepartments',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp.success){

            if (resp.data) this.tableData = resp.data

        }else{

            this.$message.error(this.$t('anErrorOccured'))

        }

        this.isLoading = false

      },
      addItem(){

           if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
           }

           this.addDialog = true

      },
      async editItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.currentEditItem = item

            this.editDepartment.name = item.name
            this.editDepartment.contact = item.contact
            this.editDepartment.idx = parseInt(item.idx)

            this.editDialog = true

      },
      deleteItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.$confirm(this.$t('deleteDepartmentQuestion'), this.$t('delete'), {
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
            })
            .then(async () => {

                let task = await this.fetchDepartmentsDB({
                    action: 'deleteDepartment',
                    params: {
                        id: item.id
                    }
                })

                if (task.success){

                    this.$message.success(this.$t('success'))
                    this.fetchDepartments()

                }else{

                    this.$message.error(this.$t('anErrorOccured'))

                }

            })
            .catch(() => {

            })

      },
      submitForm(ref){

            this.$refs[ref].validate(async (valid) => {
                if (valid) {

                    if (ref === this.addDepartmentForm){

                        let task = await this.fetchDepartmentsDB({
                            action: 'addDepartment',
                            params: {
                                idx: this.addDepartment.idx,
                                name: this.addDepartment.name,
                                contact: this.addDepartment.contact,
                                schoolyear: this.adminSchoolyear
                            }
                        })

                        if (task.success) this.$message.success(this.$t('success'))
                        else this.$message.error(this.$t('anErrorOccured'))

                    }else{

                        let newData = {}

                        if (this.currentEditItem.idx !== this.editDepartment.idx) {
                            newData['idx'] = this.editDepartment.idx
                        }

                        if (this.currentEditItem.name !== this.editDepartment.name) {
                            newData['name'] = this.editDepartment.name
                        }

                        if (this.currentEditItem.contact !== this.editDepartment.contact) {
                            newData['contact'] = this.editDepartment.contact
                        }

                        if (!this.$_.isEmpty(newData)){
                            let task = await this.fetchDepartmentsDB({
                                action: 'editDepartment',
                                params: {
                                    id: this.currentEditItem.id,
                                    data: newData
                                }
                            })

                            if (task.success) this.$message.success(this.$t('success'))
                            else this.$message.error(this.$t('anErrorOccured'))
                        }

                    }

                    this.cancelForm(ref)
                    this.fetchDepartments()

                } else {
                    return false
                }
            })

      },
      cancelForm(ref){

            this.$refs[ref].resetFields()

            if (ref === this.addDepartmentForm) this.addDialog = false
            else this.editDialog = false

      }
    },
}
</script>